import { Box, Center, HStack, Text } from '@chakra-ui/react';
import { useRouterState } from '@tanstack/react-router';
import { type FunctionComponent, type ReactNode } from 'react';

import { StyledLink } from '$/components/core/StyledLink';

interface INavbarLinkProps {
  icon: ReactNode;
  title: string;
  to: string;
  backgroundColor?: string;
  onClick?: VoidFunction;
  dataTestId?: string;
}

export const NavbarLink: FunctionComponent<INavbarLinkProps> = ({
  backgroundColor,
  icon,
  to,
  title,
  onClick,
  dataTestId,
  ...rest
}) => {
  const { pathname } = useRouterState().location;
  const isWelcomeDashboardActive = to === '/' && pathname === '/';
  const isActive =
    (pathname.startsWith(to) && to !== '/') || isWelcomeDashboardActive;

  const bg = isActive
    ? (backgroundColor ?? 'secondaryBackground')
    : 'transparent';

  return (
    <StyledLink
      to={to}
      w='full'
      px='4'
      py='3'
      data-testid={dataTestId}
      bgColor={bg}
      _hover={{ bg: !isActive ? 'bodyBackground' : bg }}
      onClick={onClick}
      {...rest}
    >
      <HStack gap='4' w='full'>
        <Box
          p='1'
          bg={!isActive ? 'bodyBackground' : bg}
          border='1px solid'
          borderColor={!isActive ? 'border' : 'transparent'}
          borderRadius='md'
        >
          <Center w='24px' h='24px'>
            {icon}
          </Center>
        </Box>
        <Text
          display={{ base: 'block', mobile: 'none', md: 'block' }}
          color='text'
          fontSize='md'
          fontWeight='bold'
        >
          {title}
        </Text>
      </HStack>
    </StyledLink>
  );
};
